import { EventTime } from '@/lib/parsers/common';
import { useDayjs } from '@/lib/utils/useDayjs';
import { useTranslations } from 'next-intl';
import Txt from '../ui/Txt';

interface Performance {
  items: EventTime[];
}

const Perfomance = ({ items }: Performance) => {
  const t = useTranslations('common');

  return items.map((item) => {
    const { isPast, soldout, status, waitlist } = item;

    if (!status) return null;

    const date = useDayjs(item?.date).format('ddd, DD MMM YYYY');
    const time = useDayjs(item?.date).format('hh:mma');
    const isWaitlistOnly = soldout && waitlist;

    return (
      <Txt
        key={item?.eventTimeId}
        as="p"
        variant="body"
        color={
          isWaitlistOnly ? 'black' : soldout ? 'error' : isPast ? 'cream' : 'black'
        }
        cx={{ mY: 'none', position: 'relative' }}>
        <Txt as="span" style={{ minWidth: '9.375rem', display: 'inline-block' }}>
          {date}
        </Txt>
        <Txt as="span">
          <Txt as="span">{time}</Txt>
          {soldout && !waitlist && (
            <Txt
              as="span"
              cx={{ pL: '3xs' }}
              color="error"
              uppercase
              variant="tiny"
              weight="bold">
              {t('soldout')}
            </Txt>
          )}
          {isWaitlistOnly && (
            <Txt as="span" cx={{ pL: '3xs' }} uppercase variant="tiny" weight="bold">
              {t('joinWaitlist')}
            </Txt>
          )}
        </Txt>
      </Txt>
    );
  });
};

export default Perfomance;
